<template>
    <div v-if="cargando">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
            </div>
        </div>
    </div>
    <div v-else>
    <b-container fluid>
    <b-row>     
        <!-- <b-col md="2">
            <b-form-group horizontal label="Orden" class="mb-0">
                <b-input-group>
                <b-form-select v-model="orden" slot="append" @input="listTicket">
                    <option :value="'asc'">Más Antiguo</option>
                    <option :value="'desc'">Más Reciente</option>
                </b-form-select>
                </b-input-group>
            </b-form-group>
        </b-col> -->
        <b-col cols="4">
          <div style="background: #f8f9fa; padding: 10px; border-radius: 5px; border-left: 5px solid #007bff; display: flex; align-items: center;">
            <h5 style="margin: 0; display: inline-flex; align-items: center;">
              <strong>📅 Boletas de la semana </strong>
            </h5>
          </div>
        </b-col>
        <b-col cols="1" sm="2"	md="2"	lg="2"	xl="4">
          <b-form inline>
              Desde: <b-input type="date" v-model="f1"/>
              Hasta: <b-input type="date" v-model="f2"/>
          <b-tooltip target="info-icon" triggers="hover">
              Buscar Boleta por rango de fecha ejemplo: Desde: 01/10/2024 Hasta: 20/10/2424
          </b-tooltip>
              <i id="info-icon" class="fas fa-question-circle text-primary" style="margin-left: 8px; cursor: pointer; font-size: 18px;"></i>
              <b-button size="sm" @click="listTicket" variant="success" class="ml-2">Buscar</b-button>
          </b-form>
        </b-col>
        <b-col>
            <template>
                <DatePicker
                    style="color: #20a8d8; border: 3px solid #20a8d8; border-radius: 8px;" 
                    placeholder="Buscar Boleta por día 📅"
                    v-model="buscarxdia" 
                    lang="es" 
                    :disabled-date="deshabilitarFechasFuturas" 
                    @input="actualizarFecha(buscarxdia)"/>
            </template>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <div class="col-md-12 text-center mt-3">
            <b-button size="sm" variant="primary" @click="listTicket">
              Actualizar Tabla <i class="fa fa-sync-alt"></i>
            </b-button>
          </div>
        </b-col>
        <b-col cols="8"></b-col>
        <b-col>
          <div class="mt-3">
            <b-button class="float-right" size="sm" variant="warning" @click="clearFechas()">
              Limpiar filtros <i class="fas fa-broom"></i> <!-- Escoba -->
            </b-button>
          </div>
        </b-col>
    </b-row>
    <br>
        <br>
        <b-table responsive 
            :small="small"
            :outlined="outlined"
            :striped="striped"
            :items="tickets"
            :fields="tickets_fields"
            :current-page="pactual"
            :per-page="limite"            
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            >
            <template slot="acredito" slot-scope="row">
                <template v-if="row.item && row.item.credito == 1">
                    <i title="Boleta a crédito" class="fa fa-copyright text-primary"></i>
                </template>
            </template>
            <template slot="estado" slot-scope="row">
                <div class="text-center">
                    <template v-if="row.item.emitido==1 && row.item.baja==1">
                        <div><span class="badge badge-dark">Baja <i class="fa fa-ban"></i></span></div>
                    </template>
                    <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                        <div><span class="badge badge-info">Baja pendiente <i class="fa fa-ban"></i></span></div>
                    </template>
                    <template v-else>
                        <div v-if="row.item.emitido==1"><span class="badge badge-success">Emitido <i class="fa fa-check"></i></span></div>
                        <div v-else-if="row.item.emitido==0"><span class="badge badge-warning" title="Las boletas se evian al final del día">Por Enviar <i class="fa fa-hourglass-half"></i></span></div>
                        <div v-else-if="row.item.emitido==8"><span class="badge badge-info" title="Las boletas se evian al final del día">En consulta<i class="fa fa-clock" aria-hidden="true"></i></span></div>
                        <div v-else-if="row.item.emitido==2"><span class="badge badge-danger">Rechazado <i class="fa fa-times"></i></span></div>
                    </template>
                </div>
            </template>
            <template slot="receptor" slot-scope="row">
                <template v-if="row.item.receiver && row.item.receiver.tipo != 0">
                    {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
                </template>
                <template v-else>
                    <template v-if="row.item.idReceptor=='-' && row.item.adicional && row.item.adicional.otroNombre">
                        {{row.item.adicional.otroNombre}}
                    </template>
                    <template v-else>
                        P&uacute;blico en General
                    </template>
                </template>
            </template>
            <template slot="emisor" slot-scope="row">
                <template v-if="row.item && row.item.adicional && row.item.adicional !=''">
                    {{row.item.adicional.username}}
                </template>   
            </template>
            <template slot="emision" slot-scope="row">
                {{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }}
            </template>
            <template slot="moneda" slot-scope="row">
                <div class="text-right">
                    <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
                    <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
                    <template v-else>{{ row.item.tipoMoneda }}</template>
                    {{row.item.importeTotal}}
                </div>
            </template>
            <template slot="acciones" slot-scope="row">
                <template v-if="row.item.emitido!=2 && row.item.baja!=1">
                    <b-button-group>
                        <button v-show="!row.item.loading" type="button" class="btn" size="sm" @click="mostrarDetalles(row, row.index)" title="Mas opciones">
                            <template v-if="!row.item.mostrardetalles">
                                <i class="fa fa-plus"></i>
                            </template>
                            <template v-else>
                                <i class="fa fa-minus"></i>
                            </template>
                        </button>
                        <b-button size="sm" v-show="row.item.loading" variant="ligth"><i class="fa fa-spin fa-spinner"></i></b-button>
                        <b-button v-b-modal.prevmodal v-b-tooltip.hover @click="viewPdf(row.item)"><i title="Vista Previa" class="fa fa-tv"></i></b-button>
                        <b-dropdown no-caret>
                            <template v-slot:button-content>
                                <i class="fa fa-chevron-down"></i>
                            </template>
                            <b-dropdown-item @click="convertirAnticipo(row.item)">
                                <i class="far fa-file mr-2 text-dark"></i> Convertir Anticipo
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i title="Descargar PDF" class="fa fa-file-pdf"></i></b-button>
                        <b-button @click="setTicket(row.item)" v-b-modal.sendboletaemail1 v-b-tooltip.hover><i class="fa fa-share-alt" title="Compartir Documento" aria-hidden="true"></i></b-button>
                        <b-button v-if="row.item.emitido==0 || row.item.emitido==3" class="disabled" :disabled="true"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                        <b-button v-else @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                        <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                        <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
                        <b-button v-b-tooltip.hover v-if="row.item.receiver.tipo != 0" variant="primary" @click="advertConvertCredit(row.item)" :disabled="row.item.credito==1"><i title="Convertir a crédito" class="fa fa-handshake text-white"></i></b-button>
                        <b-button v-b-tooltip.hover v-else variant="primary" disabled><i title="Convertir a crédito" class="fa fa-handshake text-white"></i></b-button>
                        <b-button  size="sm" variant="success" @click="duplicarBoleta(row.item, 2)" title="Boleta" ><i title="Emisión Rapida Boleta" class="fa fa-1x fa-copy"></i></b-button>
                        <b-button  size="sm" variant="warning" @click="captureItemsBoleta(row.item, 1)" title="Emisión Rapida Guia" ><i class="fa fa-1x fa-truck"></i></b-button>
                        <b-button v-if="row.item.emitido==0 || row.item.emitido==3" :disabled="true" v-b-tooltip.hover class="disabled btn btn-danger"><i title="Baja de Boleta" class="fa fa-trash-alt text-white"></i></b-button>
                        <b-button v-else @click="preBaja(row.item)" v-b-tooltip.hover class="btn btn-danger"><i title="Baja de Boleta" class="fa fa-trash-alt text-white"></i></b-button>
                    </b-button-group>
                </template>
                <template v-else>
                    <b-button-group>
                        <b-button @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
                        <b-button v-if="row.item.emitido==2" @click="estadoEmision(row.item)" v-b-modal.motivorechazo4 v-b-tooltip.hover class="btn" variant = "primary"><i title="Estado de la emision" class="fa fa-eye text-white"></i></b-button>
                    </b-button-group>
                </template>
            </template>
            <template slot="row-details" slot-scope="row">
                <b-card class="tamanioletra">
                    <b-table striped hover :items="row.item.lista" :fields="listaitems_fields" :busy="row.item.loading">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template slot="index" slot-scope="row">
                            {{ row.index+1 }}
                        </template>
                        <template slot="cantidad" slot-scope="row">
                            <div>{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
                        </template>


                        <template slot="baseAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.baseAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="montoAfectacionIgv" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template
                                v-if="row.item.precioVentaUnitario"
                            >{{ Number.parseFloat(row.item.montoAfectacionIgv).toFixed(2) }}</template>
                            </div>
                        </template>
                        <template slot="descuento" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.descuento">
                                {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                        <template slot="valorVenta" slot-scope="row">
                            <div>
                            <template v-if="row.item.moneda=='PEN'">S/</template>
                            <template v-else-if="row.item.moneda=='USD'">$</template>
                            <template v-else>{{ row.item.moneda }}</template>
                            <template v-if="row.item.tipoAfectacionIgv=='10'">            
                                  {{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                                <div style="float:right;color:red">
                                    {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                                </div>
                            </template>
                            <template v-else-if="row.item.tipoAfectacionIgv=='20' || row.item.tipoAfectacionIgv=='30'">
                                {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                            </template>
                            </div>
                        </template>
                    </b-table>
                </b-card>
            </template>
        </b-table>
        </b-container>
    <b-modal id="sendboletaemail1" title="Compartir Documento" v-model="previacorreo">
        <div style="background-color: #e7ffcd;" class="p-2" role="group">
            <label for="inputLive">Enviar por WhatsApp: 
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="20" viewBox="0 0 448 512">
                <path fill="#0dc143" d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"/></svg>
            </label>
            <b-form-input type="number" style="border-color:black" v-model="numeroWhatsApp" @keyup.enter="send_message(ticket)"></b-form-input>
            <b-form-text style="font-size: small !important; color: #ea0909 !important"
                >Ingrese su número de celular (9 dígitos)
            </b-form-text>
               <b-row>
                <b-col cols="9"></b-col>
                <b-col>
                     <b-btn
                    :disabled="numeroWhatsApp.length < 9 || numeroWhatsApp.length > 9 "
                    size="sm"
                    variant="success"
                    @click="send_message(ticket)"
                    >Enviar
                    </b-btn>
                </b-col>
               </b-row>
         </div>
        <div style="background-color: #cce6ff" class="p-2" role="group">
            <label for="inputLive">Enviar por Correo: <i class="fa fa-envelope fa-lg" aria-hidden="true"></i></label>
            <b-form-input style="border-color:black" v-model="recipients" type="email" @keyup.enter="sendMail(ticket)"></b-form-input>
             <b-form-text style="font-size: small !important; color: #ea0909 !important"
                >Ingresa un correo ó varios separados por comas (,)
            </b-form-text>
            <b-row>
                <b-col cols="9"></b-col>
                <b-col>
                    <b-btn 
                        v-if="!sendcorreo" 
                        size="sm" 
                        variant="primary" 
                        @click="sendMail(ticket)">
                        Enviar
                    </b-btn>
                    <b-btn v-else size="sm" class="float-right" variant="secondary">
                        <i class="fa fa-spin fa-spinner"></i> Enviando...
                    </b-btn>
                </b-col>
            </b-row>
        
        <hr class="mt-3">
        <label for="inputLive">Correos en módulo Negocios:</label>
        <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
        <b-badge pill variant="light">{{item}}
        <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
        </li>
        </h5>
       <b-row>
        <b-col cols="9"></b-col>
        <b-col>
            <b-button v-if="recipients!=''" :disabled="mostraremail" size="sm" @click="enviarEmail(ticket)" variant="primary">Enviar a todos</b-button>
            <b-button v-else :disabled="mostraremail"  size="sm" @click="enviarEmail(ticket)" variant="primary">Enviar</b-button>
        </b-col>
       </b-row>
        <div slot="modal-footer" class="w-100"></div>
        </div>
    </b-modal>
    <b-modal id="motivorechazo4" title="Motivo del Rechazo" v-model="motivoRechazo">
        <div role="group">
            <div v-if="spinoff">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h3>Cargando <i class="fa fa-spin fa-spinner"></i></h3>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h6>{{ descripcionRechazo }}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-btn v-if="!sendcorreo" size="sm" class="float-right" variant="primary" @click="motivoRechazo=!motivoRechazo">
                Ok
            </b-btn>
        </div>
    </b-modal>
    <b-modal id="prevmodal" size="lg" title="Vista Previa" cancel-title="Cerrar" v-model="previaboleta">
        <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
        <template v-else>
            <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
            </template>
        </template>
    </b-modal>
    <div class="row">
        <div class="col-md-6">
            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-6">
            <div class="float-right">
                <b-pagination size="sm" :total-rows="total" v-model="currentPage" @input="listTicket" :per-page="limite"></b-pagination>
            </div>            
        </div>
    </div>
    <vue-snotify></vue-snotify>
    <b-modal id="modalpreproccess" v-model="modal">
        <template slot="modal-title">
            <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a una boleta
        </template>
        <p class="my-4 h4"><b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja a la siguiente boleta?</p>
        <b-list-group>
            <template>
                <template>
                    <b-list-group-item>{{boletaItemBaja.serie + '-' + boletaItemBaja.numero + ' | ' + boletaItemBaja.idReceptor + '-' + boletaItemBaja.razonSocial}}</b-list-group-item>
                </template>
            </template>
        </b-list-group>
        <br>
        <b-alert v-if="!loading2" variant="danger" show>El siguiente procedimiento no se puede deshacer.</b-alert>
        <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
        <template slot="modal-footer">
            <template v-if="!loading2">
            <b-button variant="secondary" @click="modal=false">No</b-button>
            <b-button variant="danger" @click="sendBaja"><i class="fa fa-cog"></i> Procesar</b-button>
            </template>
            <b-button v-else disabled variant="danger"><i class="fa fa-spin fa-cog"></i> Procesando</b-button>
        </template>  
    </b-modal>  
</div>
</template>

<script>
import "vue2-datepicker/locale/es";
import DatePicker from 'vue2-datepicker';
import axios from 'axios'
import download from 'downloadjs'
export default {
    name: 'BoletaConsulta',
    components:{
        DatePicker
    },
    props: ['reload'],
    data: () => {
        return {
            motivoRechazo: false,
            spinoff: false,
            descripcionRechazo: '',
            boletaItemBaja: {
                serie: '',
                numero: '',
                idReceptor: '',
                razonSocial: ''
            },
            loading2: false,
            modal: false,
            reloadLocal: false,
            striped: true,
            outlined: true,
            small: true,
            filter: null,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            currentPage: 1,
            totalRows: null,
            previaboleta: false,
            previacorreo: false,
            sendcorreo: false,
            tickets: [],
            ticket: {},
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 100,
            orden: 'desc',
            tickets_fields: [
                {key: 'acredito', label: ''},
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emisión', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'emisor', label: 'Usuario', sortable: true},
                {key: 'moneda', label: 'Importe Total', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            listaitems_fields: [
                {key: 'index'},
                {key: 'codigoProducto', label: 'Codigo', sorteable: true},
                {key: 'unidadMedidaCantidad', label: 'Unidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                { key: "baseAfectacionIgv", label: "Valor Total", sorteable: true },
                { key: "montoAfectacionIgv", label: "IGV", sorteable: true },
                { key: "descuento", label: "Descuento", sorteable: true },
                { key: "valorVenta", label: "Precio Total", sorteable: true }
            ],
            pdfobject: '',
            cargandopdf2: false,
            recipients: '',
            serie: '',
            numero: '',
            reciveEmail:[],
            customers:[],
            currentPageTerceros:1,
            ordenTerceros:'desc',
            mostraremail:true,
            noticeEmisionGuia: false,
            bufferData: {},
            boletaItems : [],
            boletaItemsGuias : [],
            f1:"",
            f2:"",
            buscarxdia:'',
            fechaHoy:'',
            numeroWhatsApp:'',
            fechaBoletaDelDia:'',
        }
    },
    mounted () {
        this.listTicket();
         this.listTerceros();
    },
    watch: {
        reload: function () {
           this.reloadLocal = this.reload
            if(this.reloadLocal == true){
                this.listTicket()
            } 
        },
    },
    methods: {  
        mostrarDetalles: function (row, index) {
            if(row.detailsShowing){
                row.toggleDetails()
                this.tickets[index].mostrardetalles = false
            }else{
                this.tickets[index].mostrardetalles = true
                this.tickets[index].loading = true
                if(this.tickets[index].lista.length == 0){
                    setTimeout(() => 
                        this.detallesDocumento(row, index)
                    , 10);  
                }else{
                    this.tickets[index].loading = false
                    row.toggleDetails()
                } 
            }
        },
        detallesDocumento: function (row, index) {
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/items',{
                token: this.$store.getters.userToken,
                idbol: row.item.idBoleta
            })
            .then(response => (
                this.parseDetallesDocumento(response.data.response, row, index)
            ))
            .catch(error => {
                this.tickets[index].mostrardetalles = false;
                console.log(error)
            })
        },
        parseDetallesDocumento: function (value, row, index) {
            this.tickets[index].lista = []
            for (let i=0; i<value.length; i++){
                value[i].moneda = row.item.tipoMoneda
                this.tickets[index].lista.push(value[i])
            }
            this.tickets[index].loading = false
            // this.tickets[index].mostrardetalles = false
            if(value.length > 0){
                row.toggleDetails()
            }
        },
        advertConvertCredit: function (data) {
            this.$swal({
            title: 'Convertir a Credito',
            text: 'Seguro que desea convertir a credito la boleta '+ data.serie+'-'+data.numero,
            icon: 'warning',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
            if(willDelete){
                this.cargando = true;
                this.convertCredit(data)
            }
            })
        },
        convertCredit: function (data) {
            axios
           .post(process.env.VUE_APP_API_URL + 'documentoscredito/convertirdoc',{
               token: this.$store.getters.userToken,
               tipodocumento: '03',
               iddocumento: data.idBoleta
           })
           .then(response => (
               this.$snotify.success(response.data.msg,'Exito'),
               this.listTicket()
           ))
           .catch(error => (
               this.$snotify.error(error.response.data.msg,'Error')
           ))
        },      
        listTicket: function () {
            let dia1;
            let dia2;
            if(this.fechaBoletaDelDia !=''){
                dia1 = this.$moment(this.fechaBoletaDelDia).format('YYYY-MM-DD 00:00:00')
                dia2 = this.$moment(this.fechaBoletaDelDia).format('YYYY-MM-DD 23:59:59')
            }else if(this.f1 !="" && this.f2 !=""){
                dia1 = this.$moment(this.f1).format('YYYY-MM-DD 00:00:00')
                dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')      
            }
            // this.fechaHoy = this.$moment().format('DD [de] MMMM [de] YYYY');
            this.cargando = true;
            let requestData = {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            };
            // Agregar f1 y f2 solo si tienen valores
            if(dia1) {
                requestData.f1 = dia1;
            }if(dia2) {
                requestData.f2 = dia2;
            }
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas', requestData)
            .then(response => (
                this.tickets = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                this.tickets.forEach(function(element){
                    element.loading = false
                })
            ))
            .catch(error => {
                this.cargando = false;
                console.log(error);
            })
        },
        setTicket: function (data) {
            this.ticket = data;

            this.listTerceros();
            let valordata = data
            let pasandoCorreoTerceros = {}
            this.customers.forEach(function(element){
                if(valordata.receiver.idReceptor == element.documento){
                pasandoCorreoTerceros = element.emailEnvio
                }      
            })
            this.reciveEmail = pasandoCorreoTerceros;

            if(this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true,
            this.previaboleta = true,
            axios
           .post(process.env.VUE_APP_API_URL + 'boletas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
            .catch(error => (
                this.previaboleta = false,
                this.cargandopdf2 = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        sendMail: function (data) {
            this.previacorreo = true,
            this.sendcorreo = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/mail', {
                token: this.$store.getters.userToken,
                id: data.idBoleta,
                mail: this.recipients
            })
            .then(response => (
               this.sendcorreo = false,
               this.previacorreo = false,
               this.$snotify.success(response.data.message, 'Exito')
                ))
             .catch(error => (
                this.previacorreo = false,
                this.previacorreo = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        downloadPdf: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = data.serie + '-' + data.numero + '.pdf'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandopdf = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'boletas/pdf',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               file = 'data:application/pdf;base64,'+ response.data.base64,
               this.cargandopdf = false,
               download(file, name,'application/pdf'),
               this.$swal.close()
           ))
            .catch(error => (
                this.$swal.close(),
                this.$snotify.error(error.response.data.response, 'Error'),
                this.cargandopdf = false
            ))
        },
        downloadCdr: function (data){
            let tag = document.createElement('i')
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
            let file = 'data:application/pdf;base64,'+ data.pdf
            this.cargandocdr = true
            this.$swal({
                title: 'Procesando Descarga',
                content: tag,
                icon: 'info',
                buttons: false,
                dangerMode: false
            })
           axios
           .post(process.env.VUE_APP_API_URL + 'boletas/constancia',{
               token: this.$store.getters.userToken,
               id: data.idBoleta
           })
           .then(response => (
               file = 'data:application/zip;base64,'+ response.data.msg.xml,
               this.cargandocdr = false,
               download(file, name,'application/zip'),
               this.$swal.close()
           ))
           .catch(function (error){

           })
        },
        downloadXml: function (data){
            let xml = ''
            let file = ''
            let name = data.serie + '-' + data.numero + '.zip'
            let tag = document.createElement('i')
            this.cargandopdf = true
            tag.classList.add('fa','fa-spin', 'fa-spinner')
            this.$swal({
            title: 'Obteniendo XML',
            content: tag,
            icon: 'info',
            buttons: false,
            dangerMode: false
            })
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/xml', {
                token: this.$store.getters.userToken,
                id: data.idBoleta
            })
            .then(response => (
                xml = response.data.response.xml,
                file = 'data:application/zip;base64,'+ xml,
                this.downloadxml(file, name, xml),
                this.$swal.close()
            ))
            .catch(error => (
                this.$snotify.error('Error al descargar el archivo', 'Error')
            ))
        },
        downloadxml: function (file, name, xml) {
            if(xml != null){
                download(file, name,'application/zip')
            }else{
                this.$snotify.error('El documento aun no tiene constancia porque aun esta en proceso!', 'Error')
            }
            
        },
        estadoEmision: function (value) {
            this.spinoff = true
            axios
            .post(process.env.VUE_APP_API_URL + 'documento/motivorechazo', {
                token: this.$store.getters.userToken,
                serie: value.serie,
                numero: value.numero,
                tipo: '03'
            })
            .then(response => ( 
                this.descripcionRechazo = response.data.msg.descripcion,
                this.spinoff = false
            ))
            .catch(error => (
                this.$snotify.error(error.response.data, 'Error'),
                this.motivoRechazo = false,
                this.spinoff = false
            )) 
        },
        preBaja: function (value) {
            this.modal = true
            this.boletaItemBaja.serie = value.serie,
            this.boletaItemBaja.numero = value.numero,
            this.boletaItemBaja.idReceptor = value.idReceptor,
            this.boletaItemBaja.razonSocial = value.receiver.razonSocial
        },
        sendBaja: function () {
            this.loading2 = true
            axios
            .post(process.env.VUE_APP_API_URL + 'comunicacionbaja/emitir/boleta', {
                token: this.$store.getters.userToken,
                serie: this.boletaItemBaja.serie,
                numero: this.boletaItemBaja.numero
            })
            .then(response => ( 
                this.loading2 = false,               
                this.modal = false,
                this.listTicket(),
                this.$snotify.success(response.data.msg, 'Éxito')
            ))
            .catch((error) => (
                this.loading2 = false,
                this.modal = false,
                this.$snotify.error(error.response.data.response.description, 'Error')
            )) 
            this.boletaItemBaja.serie = '',
            this.boletaItemBaja.numero = '',
            this.boletaItemBaja.idReceptor = '',
            this.boletaItemBaja.razonSocial = ''
        },
        listTerceros: function() {
        axios
        .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
          token: this.$store.getters.userToken,
          page: this.currentPageTerceros,
          order: this.ordenTerceros
        })
        .then(response =>(
            this.customers = response.data
          ))
        .catch(error => (
          console.log(error)
        ))
        },
        borrarCorreo(index){
            this.reciveEmail.splice(index, 1)
            if(this.reciveEmail.length > 0){
                this.mostraremail = false;
            }else{
                this.mostraremail = true;
            }
        },
    enviarEmail: function(data) {
      for (let i = 0; i < this.reciveEmail.length; i++) {
          this.reciveEmail[i] + ","
      }
      let cadena = this.reciveEmail.join(",");
      if(this.recipients !=''){
        this.sendMail(data);  
      }  
      this.previacorreo = true;
      this.sendcorreo = true;
      axios
        .post(process.env.VUE_APP_API_URL + "boletas/mail", {
          token: this.$store.getters.userToken,
          id: data.idBoleta,
          mail: cadena
        })
        .then(
          response => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
             this.alertaenvio(response.data.msg)
          ))
        .catch(
          error => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
            this.$snotify.error(error.response.data.response, "Error")
          )
        );
    },
    alertaenvio(data){
      if(this.recipients == ''){
        this.$snotify.success(data, "Exito")
      }
    },
    convertirAnticipo(value){
      let tipo = '03';
      axios
      .post(process.env.VUE_APP_API_URL + "anticipos/convertir",{
        token: this.$store.getters.userToken,
        tipoDoc: tipo,
        idDocumento : value.idBoleta
      })
      .then(response=>(
        this.$snotify.success("Boleta Convertida en Anticipo", "Éxito")
      ))
      .catch(err=>(
       this.$snotify.warning(err.response.data.msg,"Cuidado")
      ))
    },
    // noticeEmisionQuickGuide: function(data) {
    //   (this.noticeEmisionGuia = true), (this.bufferData = data);
    // },
    duplicarBoleta(data){
    let tag = document.createElement("i");
        tag.classList.add("fa", "fa-spin", "fa-spinner");
        this.$swal({
            title: "Obteniendo Items",
            content: tag,
            icon: "info",
            buttons: false,
            dangerMode: false
        });
        axios
        .post(process.env.VUE_APP_API_URL + 'boletas/items',{
            token: this.$store.getters.userToken,
            idbol: data.idBoleta
        })
        .then(response => (
            this.boletaItems = response.data.response,
            this.emisionRapidaBoleta()
        ))
        .catch(error => {
            console.log(error)
        })
    },
    captureItemsBoleta(data){
        this.bufferData = data
        this.noticeEmisionGuia = false;
        let tag = document.createElement("i");
        tag.classList.add("fa", "fa-spin", "fa-spinner");
        this.$swal({
            title: "Obteniendo Items",
            content: tag,
            icon: "info",
            buttons: false,
            dangerMode: false
        });
        axios
        .post(process.env.VUE_APP_API_URL + 'boletas/items',{
            token: this.$store.getters.userToken,
            idbol: data.idBoleta
        })
        .then(response => (
            this.boletaItems = response.data.response,
            this.boletaItemsGuias = response.data.response,
            this.emisionRapidaGuia()
        ))
        .catch(error => {
            console.log(error)
        })      
    },
    emisionRapidaGuia: function() {
        this.$swal.close();
        this.$store.commit("datosRemitenteBoletaGuia", this.bufferData),
        this.$store.commit("setboletaGuias", this.boletaItemsGuias),
        this.$router.push("/emision/guia").catch(err => {});
    },
    emisionRapidaBoleta(){
        this.$swal.close();
        this.$store.commit("setboleta",this.boletaItems),
        this.$router.push("/emision/boleta").catch(err => {});
        this.changeTab(0);
    },
    changeTab: function(value) {
      this.$emit("tabindex", value);
    },
    closenotice: function() {
      this.noticeEmisionGuia = false;
    },
    send_message(data) {
        if(this.numeroWhatsApp && this.numeroWhatsApp.trim() !== ''){
            if(this.numeroWhatsApp.length == 9){
                const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                const {
                    idEmisor,
                    serie,
                    numero,
                    idReceptor,
                    importeTotal
                } = data
                let boleta = '03';
                const mensaje = 'Comprobante' + ' ' + data.serie +'-'+ data.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                const cadena = `${idEmisor}|${boleta}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                const text = `${url}.${btoa(cadena)}+${mensaje}`
                window.open(`https://wa.me/+51${this.numeroWhatsApp}?text=${text}`, '_blank')
            }else{
                this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
            }
        }else{
            this.$snotify.warning("DEBE INGRESAR INFORMACION")
        }
    },
    deshabilitarFechasFuturas(date) {
        return date > new Date(); // Bloquea fechas mayores a hoy
    },
    actualizarFecha(fecha) {
        if(fecha == null){
            this.fechaBoletaDelDia = '';
        }else{
            this.fechaBoletaDelDia = this.$moment(fecha).format('YYYY-MM-DD 00:00:00');
            this.listTicket();
        }
      },
      clearFechas(){
        //LIMPIA LOS FILTROS DE FECHA
        //Y TRAE LOS REGISTRO DEL DIA
        this.fechaBoletaDelDia = '';
        this.f1 ='';
        this.f2 ='';
        this.listTicket();
      }
    }
}
</script>

<style>
    .bordeplus{
        height: 30px;
        width: 30px;
        border-radius: 50px;
    }
    .tamanioletra{
        font-size: 13px;
        font-family: 'Roboto Mono';
        margin-left: 3%;
        padding: 0px;
    }
    .calendar-container {
        background-color: #20a8d8;
        border-color: #20a8d8;
        color:#fff;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        transition: transform 0.2s ease, box-shadow 0.2s ease; 
        transform: scale(1.05);
        border-radius: 15px;
        position: relative;
        z-index: 2;
        width: 260px;
        padding: 2px;
        border: 1px solid #ccc;
        display: inline-block;
        text-align: center;
        cursor: pointer;
    }
    .calendar-popup {
        position: absolute;
        top: 100%; /* Se posiciona justo debajo del input */
        left: 50%;
        transform: translateX(-50%); /* Lo centra respecto al input */
        z-index: 9999; /* Garantiza que esté por encima de todo */
        background: white;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        padding: 5px;
        border-radius: 5px;
    }

</style>
<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap');
</style>
